import React, { useState } from 'react';
import AdminProfile from './atoms/admin_profile';

const Admins = (props) => {
  // const { principal } = props;
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          width: '24.8rem',
          height: '3.8rem',
          alignItems: 'center',
          padding: '0rem 1rem 0rem 1rem',
          background: ' #7367F0',
          boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
          borderRadius: '0.6rem',
          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '1.5rem',
          lineHeight: '1.8rem',
          color: '#FFF',
        }}
      >
        <img
          width={18}
          height={18}
          src={require('../../assets/images/ico_admin_white.png')}
        />
        <div style={{ marginLeft: 10 }}>{`최고관리자 정보 및 회사정보`}</div>
      </div>
      <div style={{ marginTop: 26 }} />
      <AdminProfile {...props} />
    </div>
  );
};

export default Admins;
